export function ActionButton({ label, icon, variant = 'default', onClick, fullWidth = false }) {
  const variants = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-blue-50 text-blue-600',
    danger: 'bg-red-50 text-red-600',
    success: 'bg-green-50 text-green-700',
  };

  return (
    <button
      onClick={onClick}
      className={`
        flex items-center justify-center gap-2
        px-4 py-3 rounded-xl text-sm font-medium
        active:scale-95 transition-transform
        ${variants[variant]}
        ${fullWidth ? 'col-span-2' : ''}
      `}
    >
      {icon && <span className="flex items-center">{icon}</span>}
      {label}
    </button>
  );
}